<template>
  <b-form-row class="mb-4 align-items-center">
    <b-col cols="1" class="text-center">
      <b-button
        variant="danger"
        size="sm"
        @click="$emit('delete-ship-parcel', index)"
      >
        <i class="fas fa-trash-alt"></i>
      </b-button>
    </b-col>

    <b-col cols="1" :class="'py-1 text-center ' + (parcel.special.length > 0 ? 'text-warning' : 'text-dark')">
      <span class="fa-layers fa-fw fa-2x">
        <i class="fas fa-box"></i>
        <span class="fa-layers-counter fa-layers-bottom-right bg-danger"
          style="font-size: 1.3em;" >{{index + 1}}</span>
      </span>
    </b-col>
    <b-col>
      <b-form-row>
        <b-col>
          <b-form-input type="number" v-model="parcel.weight" :min="1"/>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="parcel.dimensions[0]" :min="1"/>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="parcel.dimensions[1]" :min="1"/>
        </b-col>
        <b-col>
          <b-form-input type="number" v-model="parcel.dimensions[2]" :min="1"/>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col class="small pt-1">
          <b-row>
            <b-col v-for="e, ix in this.niceContents" :key="ix" cols="3">
              {{ e }}
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>
    </b-col>
  </b-form-row>
</template>

<script>
export default {
  name: 'Package',
  props: {
    index: {type: Number},
    parcel: { type: Object, default() {
      return {
      contents: [],
      dimensions: [9,9,9],
      weight: 0,
      special: [],
      value: 0,
      }
    }}
  },
  computed: {
    niceContents() {
      const map = {};
      this.parcel.contents.forEach(i => {
        if(map[i.description] === undefined) { map[i.description] = 0; }
        map[i.description] = map[i.description] + 1;
      });
      return Object.entries(map).map( (e) => `${e[0]} x ${e[1]}`);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pack-and-ship/Parcel.vue